import React from 'react';

import {
  activityTemplates,
  layout
} from 'modules';

import *as ActionBar from './ActionBar/ActionBar';
import * as DeviceInformationWidget from './DeviceInformationWidget/DeviceInformationWidget';
import * as EndCustomerInformationWidget from './EndCustomerInformationWidget/EndCustomerInformationWidget';
import * as ObservedFailureWidget from './ObservedFailureWidget/ObservedFailureWidget';
import * as TriageDecisionWidget from './TriageDecisionWidget/TriageDecisionWidget';
import * as ReportedDeviceIssueWidget from './ReportedDeviceIssueWidget/ReportedDeviceIssueWidget';
import * as RMASourceInformationWidget from './RMASourceInformationWidget/RMASourceInformationWidget';
import * as Tier1ReturnAuthorizationLifeCycleWidget from './Tier1ReturnAuthorizationLifeCycleWidget/Tier1ReturnAuthorizationLifeCycleWidget';
import { useParams } from 'react-router-dom';



export const Tier1ReturnAuthorizationDetailActivity: React.FC = () => {
  const { returnAuthorizationId } = useParams<{ returnAuthorizationId: string; }>();
  return returnAuthorizationId ? (
    <activityTemplates.AdminActivityTemplate.FC disableAuthRedirector>
      <layout.ColumnBox>
        <ActionBar.FC returnAuthorizationId={returnAuthorizationId} />

        <layout.RowBox>
          <layout.ColumnBox>
            <layout.RowBox>
              <RMASourceInformationWidget.FC returnAuthorizationId={returnAuthorizationId} />
              <EndCustomerInformationWidget.FC returnAuthorizationId={returnAuthorizationId} />
            </layout.RowBox>

            <layout.RowBox>
              <DeviceInformationWidget.FC returnAuthorizationId={returnAuthorizationId} />
              <ReportedDeviceIssueWidget.FC returnAuthorizationId={returnAuthorizationId} />
            </layout.RowBox>

            <layout.RowBox>
              <ObservedFailureWidget.FC returnAuthorizationId={returnAuthorizationId} />
              <TriageDecisionWidget.FC returnAuthorizationId={returnAuthorizationId} />
            </layout.RowBox>
          </layout.ColumnBox>

          <Tier1ReturnAuthorizationLifeCycleWidget.FC returnAuthorizationId={returnAuthorizationId} />
        </layout.RowBox>

      </layout.ColumnBox>
    </activityTemplates.AdminActivityTemplate.FC>
  ) : null;
};
